import { ResourceType } from '../../../dto/resource-type.enum';

export class AddResourceData {
  constructor(public name: string, public resourceType: ResourceType) {}
}
